import { Controller } from '@hotwired/stimulus'
import * as SimpleSwitch from "a-simple-switch"

export default class extends Controller {
  initialize(){
    this._setupLabelClick()

    this.initializeSimpleSwitch()
  }

  initializeSimpleSwitch() {
    SimpleSwitch.init({
      matchSizeToFont: true
    })
  }

  // Adding these 'change' listeners allows the user to click a label associated with the switch and
  // have it do the same action as clicking the switch itself, ie. it submits the form.
  _setupLabelClick(){
    const id = this.element.id
    let associatedLabels = []
    if(this.element.id) {
      const labelsFor = Array.from(document.querySelectorAll(`label[for=${id}]`))
      associatedLabels.push(...labelsFor)
    }
    associatedLabels.push(this.element.closest("label"))
    associatedLabels = associatedLabels.filter(e => e)
    associatedLabels.forEach((label) => {
      label.addEventListener("click", (e) => {
        if(e.target !== e.currentTarget) return
        // don't directly change the input, which is the default behavior
        // for a label associated with a checkbox.
        e.preventDefault()
        this._getSwitchBtn().click()
      })
    })
  }

  _getSwitchBtn(){
    // the SimpleSwitch library inserts the switch using insertAdjacentElement + 'afterend',
    // so we can be pretty certain that nextSibling is the switch.
    const switchBtn = this.element.nextSibling
    // ...but just in case, check that it has the right class.
    if(!switchBtn.classList.contains("_simple-switch-track")) { return null }
    return switchBtn
  }
}
